<template>
  <div class="box">
    <wallet-head show_type="1" />

    <div-height height="3vw"></div-height>

    <div class="new_box">
      <img src="@/assets/img/horn.png">
      <van-swipe class="swipe" :autoplay="4000" vertical :show-indicators="false">
        <van-swipe-item v-for="val in notice" :key="val.id"
          @click="$router.push({ name: 'newdel', query: { id: val.id } })">
          <p class="one" v-if="getLang() == 'zh'">{{ val.title }}</p>
          <p class="one" v-if="getLang() == 'en'">{{ val.title_en }}</p>
          <p class="one" v-if="getLang() == 'tw'">{{ val.title_tw }}</p>
        </van-swipe-item>
      </van-swipe>
    </div>



    <div class="card">
      <div class="cards1">
        <p class="p1">{{ $t('今日分红') }}</p>
        <p class="p2">{{ today_bonus }}</p>
      </div>
      <div class="cards2">
        <p class="p1"> {{ $t('会员等级') }}</p>
        <p class="p2" v-if="info.level_id"> {{ info.level.level_name }}</p>
        <p class="p2" v-else> V0</p>
      </div>
      <div class="cards3">
        <p class="p1"> {{ $t('个人算力') }}</p>
        <p class="p2">{{ power }}</p>
      </div>
    </div>

    <div class="add_box" v-if="$store.getters.isLoggedIn">

      <div-flex>
        <div class="label">{{ $t('投资数量') }}：</div>
        <div @click="router('duihuan_list')" class="link_text">
          {{ $t('投资记录') }}
          <van-icon name="arrow" style="margin-left: 1.5vw;" />
        </div>
      </div-flex>
      <div class="border">{{ amount * 10 }}</div>
      <div class="label">{{ $t('投资倍数') }}：</div>
      <div class="border">
        <!-- <div class="icon" @click="low()">-</div> -->
        <!-- <div class="input">{{ amount }}</div> -->
        <van-stepper v-model="amount" integer min="1" />

        <!-- <div class="icon" @click="add()">+</div> -->
      </div>
      <div-height height="3vw"></div-height>
      <div class="add_box_btn">
        <van-button @click="save" size="small" round block color="rgba(32, 197, 149, 1)" :loading="loading">
          {{ $t('兑换') }}
        </van-button>
      </div>
    </div>

    <div class="add_box" v-else>
      <div class="tishi"> {{ $t('请先从左上角连接钱包') }}</div>
    </div>

    <div-height height="3vw"></div-height>

    <div class="auto-scroll-container">
      <!-- 固定表头 -->
      <div class="scroll-header">
        <div class="item"> {{ $t('用户') }}</div>

        <div class="item">{{ $t('金额') }}</div>
        <div class="item">{{ $t('时间') }}</div>
      </div>

      <!-- 自动滚动的内容区 -->
      <div class="scroll-content" :style="{ transform: `translateY(${scrollOffsetY}px)` }" ref="scrollContent">
        <!-- 数据重复两份，实现无缝 -->
        <div v-for="(item, i) in fullList" :key="i" class="row">
          <div class="cell">{{ formatAddress(item.member?.account) }}</div>
          <div class="cell">{{ item.amount }}</div>
          <div class="cell">{{ item.created_at }}</div>
        </div>
      </div>
    </div>

    <div-height height="3vw"></div-height>

    <div class="htmlcontent">
      <div v-if="getLang() == 'zh'" class="msgbox htmlcontentbox" v-html="blurb.content"></div>
      <div v-if="getLang() == 'en'" class="msgbox htmlcontentbox" v-html="blurb.content_en"></div>
      <div v-if="getLang() == 'tw'" class="msgbox htmlcontentbox" v-html="blurb.content_tw"></div>
    </div>

    <div-height height="3vw"></div-height>

    <van-popup class="popupcode" v-model="tipshow" style="width: 80%;" :close-on-click-overlay="false">
      <div class="popupbox">
        <div class="body">
          <div class="ti">{{ $t('提示') }}</div>
          <div class="content">
            <p>{{ tipmsg }}</p>
            <van-button size="small" round block color="rgba(32, 197, 149, 1)" @click="tipshow = false">
              {{ $t('确定') }}</van-button>
          </div>
        </div>
        <!-- <img src="@/assets/img/guanbi@2x.png" alt="" @click="tipshow = false"> -->
      </div>
    </van-popup>

  </div>
</template>
<script>
import { deposit } from "@/utils/index.js"
import Web3 from "web3"
export default {
  data() {
    return {
      tipshow: false,
      tipmsg: '',
      notice: [],
      info: {},
      today_bonus: "0.00",
      total_power: "0.00",
      power: "0.00",
      dab: "0.00",
      doubleList: [],
      loading: false,
      blurb: '',
      amount: 1,
      keyIndex: 0,
      // ... 你已有的字段
      scrollOffsetY: 0,
      scrollRafId: null,
      isPageVisible: true,
      singleList: [], // 单份数据（10条）
    }
  },
  computed: {
    fullList() {
      return [...this.singleList, ...this.singleList]; // 双份实现无缝
    },
    totalHeight() {
      return this.singleList.length * 40; // 40px = .row 高度
    }
  },
  created() {
    //获取公告信息
    this.get_notice()
    this.get_info()
    this.get_data()
    this.get_blurb()
    this.get_list()

  },

  mounted() {
    // 监听页面可见性
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    // 启动滚动（iOS 首次加载也能跑！）
    this.startScroll();
  },

  beforeDestroy() {
    this.stopScroll();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    startScroll() {
      this.stopScroll();
      if (!this.isPageVisible || this.totalHeight === 0) return;

      const startTime = Date.now();
      const duration = 8000; // 8秒滚完一份

      const animate = () => {
        if (!this.isPageVisible || this.totalHeight === 0) return;

        const elapsed = Date.now() - startTime;
        const progress = (elapsed % duration) / duration;
        this.scrollOffsetY = -progress * this.totalHeight;

        this.scrollRafId = requestAnimationFrame(animate);
      };

      this.scrollRafId = requestAnimationFrame(animate);
    },

    stopScroll() {
      if (this.scrollRafId) {
        cancelAnimationFrame(this.scrollRafId);
        this.scrollRafId = null;
      }
    },

    restartScroll() {
      this.$nextTick(() => {
        this.startScroll();
      });
    },

    onVisibilityChange() {
      this.isPageVisible = !document.hidden;
      if (this.isPageVisible) {
        this.restartScroll();
      } else {
        this.stopScroll();
      }
    },
    restartAnimation() {
      const el = this.$refs.scrollContent;
      if (el) {
        el.style.animation = 'none';
        el.offsetHeight; // 强制重排
        el.style.animation = '';
      }
    },
    save() {

      // if (!this.trade_password) return this.$toast(this.$t("请输入交易密码"))
      if (this.loading) return;



      this.$toast.loading({
        duration: 0,
        overlay: true
      })
      this.loading = true
      let that = this
      that.$post({
        url: "/api/v1/orders/createOrder",
        data: {
          amount: this.amount * 10,
        },
        success: (resX) => {

          console.log("购买前", resX)

          // this.$toast.loading({
          //     duration: 0,
          //     overlay: true
          // })

          that.$nextTick(() => {
            // console.log("1", that.address)
            // that.blockFun
            //     .transfer("usdt", String(that.info.usdt_price), that.address, "ether", false)
            //     .then((hash) => { that.payOrder(hash) }).catch((err) => {
            //         that.loading = false
            //         that.$toast.fail(that.$t(err.msg))
            //     })

            // that.payOrder(123132);
            // return

            that.blockFun.getEthBalance("usdt").then(res => {


              console.warn('balance', res);
              if (Number(res) < Number(resX.data.amount)) {
                that.$toast.fail(that.$t('余额不足'))
                that.$toast.clear()
                that.loading = false
              } else {


                console.log("购买前", that.local.get('account'), resX.data.amount)
                let account = that.local.get('account')




                deposit(account, resX.data.amount).then(res => {



                  // res.hash是hash
                  console.warn('hash是', res);
                  if (res.hash) {
                    that.payOrder(resX.data.id, res.hash)
                  } else {
                    // that.$toast.fail(that.$t(err.msg))
                    that.loading = false
                  }
                }).catch(err => {



                  console.log('报错2', err)
                  that.loading = false
                  that.$toast.clear()

                  that.tipmsg = that.$t("支付失败")
                  that.tipshow = true

                })
              }
            }).catch(err => {



              console.log('报错1', err)
              that.loading = false
              that.$toast.clear()

              that.tipmsg = that.$t("支付失败")
              that.tipshow = true
            })

          })
        },
        tips: (err) => {

          this.loading = false
          this.$toast.clear()

          this.tipmsg = err.message
          this.tipshow = true
        },
      })

    }, payOrder(id, hash) {


      // this.$toast.loading({
      //     duration: 0,
      //     overlay: true
      // })

      this.$post({
        url: "/api/v1/orders/paySuccess",
        data: {
          id: id,
          hash,
        },
        success: (res) => {
          console.log("支付成功", res)
          this.loading = false
          this.$toast({
            message: this.$t('成功'),

          })
        },
        tips: (err) => {
          this.loading = false
          this.$toast.clear()

          this.tipmsg = err.message
          this.tipshow = true
        },
      })
    },
    add() {
      this.amount += 1
    },
    low() {
      if (this.amount <= 1) return
      this.amount -= 1
    },


    get_notice() {
      this.$get({
        url: "/api/v1/notice/list",
        success: (res) => {
          this.notice = res.data.data
        },
        tip: () => { },
      })
    },

    get_info() {

      this.$get({
        url: "/api/v1/member/getMemberInfo",
        success: (res) => {
          this.info = res.data || {};
          this.local.set('account', res.data.account);

        },
        fail: () => {

        },
      });
    },
    get_data() {
      this.$get({
        url: "/api/v1/member/getStatistics",
        success: (res) => {
          this.today_bonus = res.data.today_bonus * 1;
          this.total_power = res.data.total_power * 1;
          this.power = res.data.power * 1;
          this.dab = res.data.dab * 1;
        },
        fail: () => { },
      });
    },
    get_blurb() {
      this.$get({
        url: "/api/v1/article/getInfo?id=3",
        success: (res) => {
          console.log("获取文章详情", res.data);
          this.blurb = res.data;
        },
        fail: () => { },
      });
    },
    get_list() {
      this.$get({
        url: "/api/v1/orders/homeList",
        success: (res) => {
          let data = res.data || [];
          let list = [];

          if (data.length === 0) {
            list = Array(10).fill(null).map(() => ({}));
          } else if (data.length < 10) {
            while (list.length < 10) {
              list.push({ ...data[list.length % data.length] });
            }
          } else {
            list = data.slice(0, 10).map(item => ({ ...item }));
          }

          this.singleList = list;
          this.restartScroll();
        },
        tip: () => {
          this.singleList = Array(10).fill(null).map(() => ({}));
          this.restartScroll();
        },
      });
    },
    // 工具：格式化地址
    formatAddress(addr) {
      if (!addr) return "";
      return addr.length > 10
        ? addr.substring(0, 6) + "..." + addr.substring(addr.length - 4)
        : addr;
    },

  },
}
</script>
<style lang="less" scoped>
.box {
  width: 100%;

  .new_box {
    margin: 0 auto;
    width: 94vw;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid rgba(32, 197, 149, 1);
    border-radius: 2vw;
    background: #272c52;
    padding: 1vw 3vw;

    img {
      width: 6vw;
      height: 6vw;

      &:nth-child(3) {
        width: 15px;
        height: 15px;
      }
    }

    .gogngao_img {
      height: 8vw;
      display: flex;
      align-items: center;

      img {
        width: 15px;
        height: 15px;
      }
    }

    .swipe {
      flex: 1;
      height: 8vw;

      .van-swipe-item {
        width: 100%;
        height: 8vw;
        padding: 0 12px;

        >p {
          width: 100%;
          line-height: 8vw;
          font-size: 14px;
          font-weight: 550;
        }
      }
    }
  }

  .add_box {
    width: 90vw;
    height: 69vw;
    border-radius: 3vw;
    background: url("~@/assets/img/kuang.png") no-repeat;
    margin: 0 auto;
    background-size: 100%;
    background-position: center;
    padding: 7vw;

    .tishi {
      height: 52vw;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
    }

    .label {
      font-size: 4vw;
      color: #fff;
      padding: 2vw 0;
      display: flex;
    }

    .border {
      display: flex;
      font-size: 4vw;
      color: #fff;
      padding: 1.5vw;
      border: 1px solid #20c595;
      border-radius: 2vw;
      justify-content: space-between;

      .icon {
        font-size: 10vw;
        // height: 4vw;
        line-height: 0.5;
      }
    }
  }


  .htmlcontent {
    width: 90vw;
    background: #272c52;
    padding: 3vw;
    margin: 0 auto;
    border-radius: 2vw;
  }

  .card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4vw;

    .cards1 {
      width: 45vw;
      height: 26vw;
      border-radius: 3vw;
      background: url("~@/assets/img/lunpan.gif") no-repeat;

      background-size: 30vw 30vw;
      background-position: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .p1 {
        font-size: 3.5vw;
        color: #fff;
        margin-bottom: 1vw;
        text-align: center;
      }

      .p2 {
        font-size: 4vw;
        color: #fff;
        font-weight: 550;
        text-align: center;
      }
    }

    .cards2 {
      width: 60vw;
      height: 40vw;
      border-radius: 3vw;
      background: url("~@/assets/img/lunpan.gif") no-repeat;

      background-size: 35vw 35vw;
      background-position: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .p1 {
        font-size: 3.5vw;
        color: #fff;
        margin-bottom: 1vw;
        text-align: center;
      }

      .p2 {
        font-size: 4vw;
        color: #fff;
        font-weight: 550;
        text-align: center;
      }
    }

    .cards3 {
      width: 45vw;
      height: 26vw;
      border-radius: 3vw;
      background: url("~@/assets/img/lunpan.gif") no-repeat;

      background-size: 30vw 30vw;
      background-position: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .p1 {
        font-size: 3.5vw;
        color: #fff;
        margin-bottom: 1vw;
        text-align: center;
      }

      .p2 {
        font-size: 4vw;
        color: #fff;
        font-weight: 550;
        text-align: center;
      }
    }
  }


  .auto-scroll-container {
    width: 90vw;
    height: 50vw;
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid #20c595;
    margin: 0 auto;
    position: relative;

    .scroll-header {
      display: flex;
      background: #272c52;
      color: #fff;
      font-weight: bold;
      padding: 8px 0;
      border-bottom: 1px solid #444;
      position: absolute;
      z-index: 1;
      width: 100%;
    }

    .scroll-header .item {
      flex: 1;
      text-align: center;
      padding: 4px;
    }

    .scroll-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      background: #272c52;
      transition: none !important;
      /* 禁用过渡 */
      will-change: transform;
      /* 提升性能 */
    }

    .row {
      display: flex;
      height: 40px;
      line-height: 40px;
      color: #fff;
      border-bottom: 1px solid #2a2a2a;
    }

    .cell {
      flex: 1;
      text-align: center;
      padding: 0 8px;
      font-size: 12px;
      line-height: 1.5;
      display: flex;
      align-items: center;
      justify-content: center;
      /* 和容器高度一致 */
    }

    @keyframes scrollUp {
      0% {
        transform: translateY(0);
      }

      100% {
        transform: translateY(-50%);
      }
    }
  }

}


/deep/.popupcode {
  background: none;

  .popupbox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .body {
      width: 100%;
      background: #141629;
      border-radius: 12px;
      overflow: hidden;
      margin-bottom: 20px;

      .ti {
        width: 100%;
        background: rgba(32, 197, 149, 1);
        padding: 11px 0;
        color: #fff;
        font-size: 18px;
        text-align: center;
      }

      .content {
        width: 100%;
        padding: 25px 20px 48px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        >p {
          color: #fff;
          font-size: 14px;
          margin-bottom: 35px;
        }

        .van-button {
          width: 60%;
          padding: 14px 10px;

          .van-button__text {
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }

    img {
      width: 50px;
      height: 50px;
    }
  }
}

:deep(.van-stepper) {
  display: flex;
  width: 100%;

  .van-stepper__input {
    flex: 1;
  }

  .van-stepper__minus--disabled,
  .van-stepper__plus--disabled {
    color: #fff;
    background-color: transparent;
  }

  .van-stepper__minus,
  .van-stepper__plus {
    color: #fff;
    background-color: transparent;
  }

  .van-stepper__input {
    color: #fff;
    background-color: transparent;
  }
}

.link_text {
  color: #00ffb5;
}
</style>